import React from 'react';
import Sidebar from '../Sidebar/Sidebar';

const Admin = () => {
    return (
        <div>
            <Sidebar/>
        </div>
    );
};

export default Admin;